import { render, staticRenderFns } from "./AppQuickNav.vue?vue&type=template&id=0225a99f&scoped=true"
import script from "./AppQuickNav.vue?vue&type=script&lang=js"
export * from "./AppQuickNav.vue?vue&type=script&lang=js"
import style0 from "./AppQuickNav.vue?vue&type=style&index=0&id=0225a99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225a99f",
  null
  
)

export default component.exports